import { ThemeProvider } from '@seddi/ui-kit';
import log from 'loglevel';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import store from './store';
import { GlobalStyle } from './styles/globalStyles';
import { ThemeApp } from './styles/theme';
import { AppWrapper } from './AppWrapper';

// Setup log level.
log.setLevel('info');

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={ThemeApp}>
      <HelmetProvider>
        <GlobalStyle />
        <AppWrapper />
      </HelmetProvider>
    </ThemeProvider>
  </Provider>,
);
